export const EOfferExportPageSource = {
   0: "UNKNOWN",
   1: "BASKET",
   2: "CHECKOUT",
   3: "ORDER_DETAIL",
   "-1": "ALL",
};
